import { render } from "./AbsoluteMenu.vue?vue&type=template&id=e404bacc&scoped=true"
import script from "./AbsoluteMenu.vue?vue&type=script&lang=js"
export * from "./AbsoluteMenu.vue?vue&type=script&lang=js"

import "./AbsoluteMenu.vue?vue&type=style&index=0&id=e404bacc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e404bacc"]])

export default __exports__